import { render, staticRenderFns } from "./IndexSimulasiAnggaran.vue?vue&type=template&id=17a9e662&"
import script from "./IndexSimulasiAnggaran.vue?vue&type=script&lang=js&"
export * from "./IndexSimulasiAnggaran.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports